import React, { useState, useEffect } from "react";
import "./SetUpWagers.css";
import Player from "./Player";
import { db } from "./firebase";
import { useStateValue } from "./StateProvider";

function SetUpWagers({ id }) {
  const [{ players }, dispatch2] = useStateValue();
  const [, dispatch] = useStateValue();
  const [{ eventDate }] = useStateValue();
  const [inGroupSkins, setInGroupSkins] = useState();
  const [skinWager, setSkinWager] = useState();
  const [inLow9, setInLow9] = useState();
  const [low9, setLow9] = useState();
  const [team, setTeam] = useState();
  const [inteam9, setInTeam9] = useState();
  const [submitted, setSubmitted] = useState();

  useEffect(() => {
    const player = players?.find((p) => p.id === id);
    // console.log(pteam?.team);
    setInGroupSkins(player.inGroupSkins);
    setSkinWager(player.skinWager);
    setInLow9(player.inLow9);
    setLow9(player.low9);
    setTeam(player.team ? player.team : "Plus");
    setInTeam9(player.inTeam9);
    setSubmitted(player.isSubmitted);
  }, []);
  const inSkinsClick = (e) => {
    setInGroupSkins(!inGroupSkins);
  };
  const perSkinClick = (e) => {
    setSkinWager(e.target.value);
  };
  const inLow9Click = (e) => {
    setInLow9(!inLow9);
  };
  const low9Click = (e) => {
    setLow9(e.target.value);
  };

  const TeamClick = (event) => {
    event.target.value === "Plus" ? setTeam("Minus") : setTeam("Plus");
  };
  const inteam9Click = (e) => {
    setInTeam9(!inteam9);
  };

  const onDeletePlayer = (event) => {
    event.preventDefault();
    // console.log("Delete Pressed", event);
    const deleteGolfer = players.find((s) => s.idgolfer === id);
    dispatch2({
      type: "DELETEPLAYER",
      id: id,
    });

    db.collection("events")
      .doc(eventDate)
      .collection("scores")
      .doc(deleteGolfer.name)
      .update({
        isLocked: false,
        startScoreTime: "",
        scorer: "",
      });
  };

  // }

  const onSubmitForm = (event) => {
    event.preventDefault();
    // console.log("onSubmitForm", event.target);
    setSubmitted(true);
    dispatch({
      type: "ADDWAGERS",
      id: id,
      inGroupSkins: event.target[0].checked,
      skinWager: event.target[1].value,
      inLow9: event.target[2].checked,
      low9: event.target[3].value,
      // inLow18: event.target[4].checked,
      // low18: event.target[5].value,
      team: team,
      inTeam9: inteam9,
      // inTeam18: event.target[8].checked,
      isSubmitted: true,
    });
  };

  //change submit button to green once submitted
  const styleSaved = () => {
    const splayer = players.find((p) => p.id === id);
    return submitted ? { color: "black", backgroundColor: "lightgreen" } : {};
  };

  // needs work *******************************************************
  const itemChanged = (event) => {
    setSubmitted(false);
    dispatch({
      type: "WAGERSCHANGED",
      id: id,
      isSubmitted: false,
    });
  };

  return (
    <div>
      <form
        onChange={(e) => itemChanged(e)}
        className="wagers"
        onSubmit={(e) => onSubmitForm(e)}
      >
        <Player id={id} />
        <div className="bets">
          <div className="skinbet">
            <label className="skins__label">
              <input
                className="inSkins"
                type="checkbox"
                defaultChecked="true"
                checked={inGroupSkins}
                onClick={(e) => inSkinsClick(e)}
              />
              Skins
            </label>
            <label className="perhole__label">
              Per Hole:
              <input
                className="perHole"
                name="perSkin"
                type="number"
                defaultValue="2"
                value={skinWager}
                onChange={(e) => perSkinClick(e)}
              />
            </label>
          </div>

          <div className="lowscores">
            <p>Low</p>
            <label>
              <div className="low9__group">
                <input
                  type="checkbox"
                  defaultChecked="true"
                  className="inLow9"
                  checked={inLow9}
                  onClick={(e) => inLow9Click(e)}
                />
                9
                <input
                  className="low9"
                  name="low9"
                  type="number"
                  defaultValue="5"
                  value={low9}
                  onChange={(e) => low9Click(e)}
                />
              </div>
            </label>

            {/* <label>
              <div className="low18__group">
                <input type="checkbox" className="inLow18" />
                18
                <input
                  className="low18"
                  name="low18"
                  type="number"
                  defaultValue="5"
                />
              </div>
            </label> */}
          </div>
          <div className="teams">
            <label className="team__label">
              Team:
              <input
                className="team"
                name="Team"
                type="text"
                style={{
                  color: team === "Plus" ? "" : "white",
                  backgroundColor: team === "Plus" ? "" : "black",
                }}
                value={team}
                onClick={(e) => TeamClick(e)}
              />
            </label>
            <div className="team__holes">
              <label>
                <input
                  type="checkbox"
                  className="inTeam9"
                  checked={inteam9}
                  onClick={(e) => inteam9Click(e)}
                />
                By 9?
              </label>
              <label>
                <input type="checkbox" className="inTeam18" />
                By 18?
              </label>
            </div>
          </div>

          {/* <button className="delete__button" onClick={(e) => onDeletePlayer(e)}>Delete Player</button> */}
          {/* <button  style={styleSaved} className="submit__button">Save Wagers</button> */}

          <button style={styleSaved()} className="submit__button" type="Submit">
            Submit
          </button>
        </div>
      </form>
    </div>
  );
}

export default SetUpWagers;
